import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface FieldAlyticsActiveOrder {
  number: string;
  error?: string;
}

const useGetFieldAlyticsActiveOrders = (orderNumberFilter: string, options?: QueryOptions<FieldAlyticsActiveOrder[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  const urlParams = new URLSearchParams();
  if (orderNumberFilter) urlParams.append('orderNumberFilter', orderNumberFilter);
  return useUserOrEmployeeQuery<FieldAlyticsActiveOrder[]>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/activeOrders?${urlParams.toString()}` },
    { ...options, rewriteToEmployeeApi: false }
  );
};

export default useGetFieldAlyticsActiveOrders;
